import { HQCertificateWithFileUrl } from 'hq/services/accreditations-service.types';
import { WorkerList } from 'hq/services/flex-worker-service.types';
import {
  AccreditationForm,
  AccreditationFormTypes,
  CertificateWithFileUrl,
} from 'shared/components/forms/accreditation-form/accreditation-form';
import { FlexWorkerSelectStateProps } from '../../flexWorkers/flex-worker-select';

export type { AccreditationFormTypes };

type AccreditationFormProps = FlexWorkerSelectStateProps & {
  certificates: HQCertificateWithFileUrl[];
  flexWorkers: WorkerList[];
  formState: 'create' | 'update';
};

export const AccreditationFormHQ = (props: AccreditationFormProps) => {
  const certificates: CertificateWithFileUrl[] = props.certificates.map((cert) => ({
    id: cert.id,
    name: cert.name,
    canHaveReceipt: cert.canHaveReceipt,
    fileUrl: cert.fileUrl,
  }));

  return (
    <AccreditationForm
      certificates={certificates}
      formState={props.formState}
      flexWorkers={props.flexWorkers}
      flexWorkerOption={props.flexWorkerOption}
      flexWorkerSearch={props.flexWorkerSearch}
      setFlexWorkerSearch={props.setFlexWorkerSearch}
      setFlexWorkerOption={props.setFlexWorkerOption}
      flexWorkerDisabled={props.formState === 'update'}
    />
  );
};
